export const selectHasInitializedMessages = (state) => state.chat.hasInitializedMessages;
export const selectMessages = (state) => state.chat.messages;
export const selectIsTyping = (state) => state.chat.isTyping;
export const selectIsAssistantResponding = (state) => state.chat.isAssistantResponding;
export const selectedValues = (state) => state.chat.selectedValues;
export const selectIsChatOpen = (state) => state.chat.isChatOpen;
export const selectErrorMessage = (state) => state.chat.errorMessage;
export const selectIsChatExpanded = (state) => state.chat.isChatExpanded
export const selectTaskStatusMessage = (state) => state.chat.taskStatusMessage;
export const selectWelcomeSuggestions = (state) => state.chat.welcomeSuggestions;
